<template>
  <section class="features-premium" id="features">
    <div class="features-bg-premium">
      <div class="gradient-mesh mesh-1"></div>
      <div class="gradient-mesh mesh-2"></div>
      <div class="grid-pattern"></div>
    </div>
    
    <div class="container">
      <!-- Premium Features Grid -->
      <div class="features-grid-premium">
        <!-- Feature 1 -->
        <div class="feature-card-premium fade-in-up delay-3">
          <div class="card-shine"></div>
          <h3 class="feature-title-premium">Codice Lotteria Istantaneo</h3>
          <p class="feature-desc-premium">
            Genera e salva il tuo codice lotteria in un tap. Mostralo facilmente agli esercenti con il QR code integrato.
          </p>
          <div class="feature-badge-premium">
            <span>✓ Sempre disponibile</span>
          </div>
        </div>

        <!-- Feature 2 -->
        <div class="feature-card-premium fade-in-up delay-4">
          <div class="card-shine"></div>
          <h3 class="feature-title-premium">Zero Registrazione</h3>
          <p class="feature-desc-premium">
            Nessuna email, nessuna password, nessuna complicazione. Inizia subito a usare l'app senza perdere tempo.
          </p>
          <div class="feature-badge-premium">
            <span>✓ Accesso immediato</span>
          </div>
        </div>

        <!-- Feature 3 -->
        <div class="feature-card-premium fade-in-up delay-5">
          <div class="card-shine"></div>
          <h3 class="feature-title-premium">Liste Condivise</h3>
          <p class="feature-desc-premium">
            Crea liste della spesa collaborative che si sincronizzano in tempo reale con tutta la famiglia.
          </p>
          <div class="feature-badge-premium">
            <span>✓ Sync in tempo reale</span>
          </div>
        </div>

        <!-- Feature 4 -->
        <div class="feature-card-premium fade-in-up delay-6">
          <div class="card-shine"></div>
          <h3 class="feature-title-premium">100% Gratuita</h3>
          <p class="feature-desc-premium">
            Tutte le funzionalità premium incluse senza costi nascosti, abbonamenti o pubblicità invasive.
          </p>
          <div class="feature-badge-premium">
            <span>✓ Gratis per sempre</span>
          </div>
        </div>
      </div>

      <!-- Premium CTA -->
      <div class="features-cta-premium fade-in-up delay-7">
        <div class="cta-glow"></div>
        <div class="cta-content-premium">
          <h3>Pronto a semplificare la tua vita?</h3>
          <p>Scarica AppScontrini e inizia subito a partecipare alla Lotteria degli Scontrini</p>
        </div>
        <a href="#download" class="cta-button-premium" @click.prevent="scrollToDownload">
          <i class="icon-cloud-download"></i>
          <span>Scarica Ora</span>
          <div class="button-glow"></div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturesSection',
  methods: {
    scrollToDownload() {
      const element = document.querySelector('#download')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

.features-premium {
  position: relative;
  padding: 140px 0;
  background: #f8f9fc; // Grigio chiaro elegante a tinta unita
  overflow: hidden;

  .features-bg-premium {
    display: none; // Rimossi elementi sfumati per un look più pulito
  }

  .container {
    position: relative;
    z-index: 1;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .features-header-premium {
    text-align: center;
    margin-bottom: 80px;

    .header-badge {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      padding: 10px 24px;
      background: linear-gradient(135deg, rgba($theme-primary, 0.08), rgba($theme-primary, 0.12));
      border: 1px solid rgba($theme-primary, 0.15);
      border-radius: 50px;
      color: $theme-primary;
      font-size: 0.9rem;
      font-weight: 700;
      margin-bottom: 24px;
      letter-spacing: 0.5px;
      text-transform: uppercase;

      .badge-pulse {
        width: 8px;
        height: 8px;
        background: $theme-primary;
        border-radius: 50%;
        animation: pulse-badge 2s ease-in-out infinite;
      }
    }

    .features-title-premium {
      font-size: 3.5rem;
      font-weight: 900;
      line-height: 1.15;
      color: #1a1a1a;
      margin-bottom: 24px;
      letter-spacing: -0.02em;

      @media (max-width: 768px) {
        font-size: 2.2rem;
      }

      .title-highlight {
        background: linear-gradient(135deg, $theme-primary 0%, #667eea 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        position: relative;
        display: inline-block;

        &::after {
          content: '';
          position: absolute;
          bottom: -4px;
          left: 0;
          width: 100%;
          height: 3px;
          background: linear-gradient(90deg, $theme-primary, #667eea);
          border-radius: 2px;
          opacity: 0.3;
        }
      }
    }

    .features-desc-premium {
      font-size: 1.15rem;
      color: #666;
      max-width: 700px;
      margin: 0 auto;
      line-height: 1.7;
      font-weight: 400;

      @media (max-width: 768px) {
        font-size: 1rem;
      }
    }
  }

  .features-grid-premium {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    margin-bottom: 80px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 24px;
    }
  }

  .feature-card-premium {
    position: relative;
    background: #ffffff;
    border-radius: 16px;
    padding: 40px 36px;
    transition: all 0.3s ease;
    border: 1px solid #e8eaef;
    overflow: hidden;
    box-shadow: none;

    .card-shine {
      display: none; // Rimosso effetto shine per un look più sobrio
    }

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 32px rgba(30, 60, 114, 0.08);
      border-color: rgba($theme-primary, 0.2);
    }

    .feature-title-premium {
      font-size: 1.5rem;
      font-weight: 800;
      color: #1a1a1a;
      margin-bottom: 14px;
      line-height: 1.3;
      letter-spacing: -0.01em;
    }

    .feature-desc-premium {
      font-size: 1.05rem;
      color: #666;
      line-height: 1.7;
      margin-bottom: 24px;
      font-weight: 400;
    }

    .feature-badge-premium {
      display: inline-flex;
      align-items: center;
      padding: 8px 18px;
      background: linear-gradient(135deg, rgba($theme-primary, 0.08), rgba($theme-primary, 0.12));
      border: 1px solid rgba($theme-primary, 0.15);
      border-radius: 50px;
      color: $theme-primary;
      font-size: 0.85rem;
      font-weight: 700;

      span {
        letter-spacing: 0.3px;
      }
    }
  }

  .features-cta-premium {
    position: relative;
    text-align: center;
    padding: 70px 50px;
    background: #1e3c72; // Colore a tinta unita coordinato con Hero
    border-radius: 20px;
    color: white;
    overflow: hidden;
    box-shadow: none;

    .cta-glow {
      display: none; // Rimosso per un look più pulito
    }

    .cta-content-premium {
      position: relative;
      z-index: 1;
      margin-bottom: 36px;

      h3 {
        font-size: 2.2rem;
        font-weight: 800;
        margin-bottom: 14px;
        letter-spacing: -0.01em;

        @media (max-width: 768px) {
          font-size: 1.7rem;
        }
      }

      p {
        font-size: 1.15rem;
        opacity: 0.95;
        font-weight: 400;

        @media (max-width: 768px) {
          font-size: 1rem;
        }
      }
    }

    .cta-button-premium {
      position: relative;
      display: inline-flex;
      align-items: center;
      gap: 12px;
      padding: 18px 44px;
      background: white;
      color: $theme-primary;
      border-radius: 50px;
      font-size: 1.15rem;
      font-weight: 800;
      text-decoration: none;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      overflow: hidden;
      z-index: 1;
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);

      .button-glow {
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
        transition: left 0.6s ease;
      }

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 18px 42px rgba(0, 0, 0, 0.35);

        .button-glow {
          left: 100%;
        }
      }
    }
  }
}

// Animations
@keyframes float-mesh {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33% { transform: translate(60px, -60px) scale(1.15); }
  66% { transform: translate(-40px, 40px) scale(0.95); }
}

@keyframes pulse-badge {
  0%, 100% { opacity: 1; transform: scale(1); box-shadow: 0 0 0 0 rgba($theme-primary, 0.7); }
  50% { opacity: 0.7; transform: scale(1.1); box-shadow: 0 0 0 8px rgba($theme-primary, 0); }
}

@keyframes pulse-cta {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

.fade-in-up {
  animation: fadeInUp 0.8s ease-out forwards;
  opacity: 0;
  transform: translateY(30px);
}

.delay-1 { animation-delay: 0.1s; }
.delay-2 { animation-delay: 0.2s; }
.delay-3 { animation-delay: 0.3s; }
.delay-4 { animation-delay: 0.4s; }
.delay-5 { animation-delay: 0.5s; }
.delay-6 { animation-delay: 0.6s; }
.delay-7 { animation-delay: 0.7s; }

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

